import { removeEndSlash, sanitizeUrl, withEndSlash } from '@/utils/millesimaUtils';

const buildLinkedData = (url, breadcrumb) => {
	if (breadcrumb && breadcrumb.length > 0) {
		return {
			'@context': 'https://schema.org',
			'@type': 'BreadcrumbList',
			itemListElement: breadcrumb.map((elem, key) => {
				const breadcrumdJson = {
					'@type': 'ListItem',
					// Google requires 1-based positions
					position: key + 1,
					name: elem.name,
				};
				if (elem.url) {
					breadcrumdJson.item = getItemValue(url, elem);
				}
				return breadcrumdJson;
			}),
		};
	}
	return '';
};

const getItemValue = (url, elem) => {
	const base = withEndSlash(url);

	// The first entry carries the base url itself, stripped of its trailing slash:
	// resolving it like the other entries would concatenate it with the base.
	if (removeEndSlash(elem.url) === removeEndSlash(url)) {
		return base;
	}

	return sanitizeUrl(base, elem.url, elem.isSpirit);
};

export default buildLinkedData;
